export type {
  AppConfig,
  AuthConfig,
  OktaConfig,
  ServerConfigurationResponse,
  ServerConfigurationSso,
} from "./types";

export {
  applyServerConfiguration,
  getConfig,
  getVersionLabelFromServerResponse,
  loadRuntimeConfig,
} from "./config";
